/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ExportRequestMktuListInner } from './ExportRequestMktuListInner'
import {
  ExportRequestMktuListInnerFromJSON,
  ExportRequestMktuListInnerFromJSONTyped,
  ExportRequestMktuListInnerToJSON,
} from './ExportRequestMktuListInner'

/**
 *
 * @export
 * @interface ExportRequest
 */
export interface ExportRequest {
  /**
   * Выбранные классы и фразы
   * @type {Array<ExportRequestMktuListInner>}
   * @memberof ExportRequest
   */
  mktuList: Array<ExportRequestMktuListInner>
}

/**
 * Check if a given object implements the ExportRequest interface.
 */
export function instanceOfExportRequest(value: object): value is ExportRequest {
  if (!('mktuList' in value) || value['mktuList'] === undefined) return false
  return true
}

export function ExportRequestFromJSON(json: any): ExportRequest {
  return ExportRequestFromJSONTyped(json, false)
}

export function ExportRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExportRequest {
  if (json == null) {
    return json
  }
  return {
    mktuList: (json['mktuList'] as Array<any>).map(
      ExportRequestMktuListInnerFromJSON
    ),
  }
}

export function ExportRequestToJSON(value?: ExportRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    mktuList: (value['mktuList'] as Array<any>).map(
      ExportRequestMktuListInnerToJSON
    ),
  }
}
